import { EPaymentFrequency } from '@if/core/types'
import { useUser } from '@src/providers/UserProvider'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'
import { useMemo } from 'react'
import { getAllLoanCalendarValidIntervalForNewFirstPaymentDateForOperation } from './LoanCalendarFrequency-selectors'

export const useShouldDisableDateForNewFirstPayment = (
  simulation: CalendarSimulation,
  frequency: EPaymentFrequency,
) => {
  const user = useUser()
  const canBypassAcpLock = user?.rights.canEditLockedPpaPayments ?? false
  return useMemo(() => {
    const intervals = getAllLoanCalendarValidIntervalForNewFirstPaymentDateForOperation(
      simulation,
      frequency,
      canBypassAcpLock,
    )
    return (date: Date) => {
      return !intervals.some(([min, max]) => date >= min && date <= max)
    }
  }, [simulation, frequency, canBypassAcpLock])
}
